import Vue from 'vue';

Vue.component('tiktok-embed-component', {
    props: {
        id: {
            type: String,
            required: true,
        },
        width: {
            type: [String, Number],
            default: 1200,
        },
        height: {
            type: [String, Number],
            default: 675,
        },
        controls: {
            type: [String, Number],
            default: 1,
        },
        autoplay: {
            type: [String, Number],
            default: 0,
        },
        description: {
            type: [String, Number],
            default: 1,
        },
        musicInfo: {
            type: [String, Number],
            default: 1,
        },
    },
    data() {
        return {
            embedHtml: null,
        };
    },
    mounted() {
        if (this.id) {
            const videoId = this.id;
            // Build player URL with options, always set autoplay=0
            const params = [
                `controls=${this.controls}`,
                'autoplay=0',
                `description=${this.description}`,
                `music_info=${this.musicInfo}`,
            ].join('&');
            const src = `https://www.tiktok.com/player/v1/${videoId}?${params}`;
            const { width } = this;
            const { height } = this;
            this.embedHtml = `<div class="tiktok-player-wrapper">
                    <iframe
                        id="tiktok-player-iframe-${videoId}"
                        src="${src}"
                        width="${width}"
                        height="${height}"
                        frameborder="0"
                        allowfullscreen
                        allow="encrypted-media"
                        title="TikTok video player"
                        style="border-radius:16px;box-shadow:0 2px 16px rgba(0,0,0,0.12);max-width:100%;background:#000;"
                    ></iframe>
                </div>`;

            this.$nextTick(() => {
                const iframe = document.getElementById(`tiktok-player-iframe-${videoId}`);
                if (iframe && 'IntersectionObserver' in window) {
                    const observer = new window.IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                // Autoplay only the first time in view
                                iframe.contentWindow.postMessage({ type: 'play', 'x-tiktok-player': true }, '*');
                                observer.disconnect();
                            }
                        });
                    }, { threshold: 0.5 });
                    observer.observe(iframe);
                }
            });
        } else {
            this.embedHtml = '<div style="text-align:center;color:#c00;padding:2em;">Video niet gevonden of fout bij laden.</div>';
        }
    },
    template: `
        <div v-if="embedHtml" v-html="embedHtml"></div>
        <div v-else style="text-align:center;padding:2em;">Loading TikTok video…</div>
    `,
});
